import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const NoResult = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 113 88"
    fill="none"
    data-test="no-result"
    {...props}
  >
    <path
      d="M108.421 51.4894C108.42 43.849 106.709 36.3056 103.414 29.4123C100.119 22.5191 95.3226 16.4507 89.3771 11.652C83.4316 6.85344 76.4875 3.4463 69.0539 1.68044C61.6204 -0.0854244 53.8859 -0.165234 46.4175 1.44686C38.9491 3.05895 31.9362 6.32207 25.893 10.997C19.8497 15.6719 14.9293 21.64 11.4926 28.4638C8.05585 35.2877 6.18989 42.7941 6.03151 50.4329C5.87313 58.0716 7.42636 65.649 10.5773 72.6094H103.864C106.873 65.9755 108.427 58.774 108.421 51.4894Z"
      fill="#F5F4F4"
    />
    <path
      d="M6.66016 72.6094H106.5"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.900391 72.6094H4.10039"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.061 72.6094H112.261"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.4901 84.6414C88.4901 85.9214 74.4101 87.0734 56.9125 87.0734C39.4149 87.0734 25.3477 85.9854 25.3477 84.6414C25.3477 83.2974 39.4277 82.2094 56.9125 82.2094C74.3973 82.2094 88.4901 83.3614 88.4901 84.6414Z"
      fill="#F5F4F4"
    />
    <circle cx="55.2803" cy="41.9687" r="25.4746" fill="#B56DC6" />
    <circle cx="55.2802" cy="41.9688" r="20.2577" fill="#FDF5FF" />
    <circle cx="55.28" cy="41.9688" r="10.1111" fill="#E6FBFF" />
    <circle cx="55.2802" cy="41.9688" r="4.99988" fill="#C2F0FC" />
    <path
      d="M46.1106 65.7298L44.2351 72.4975H35.7764L38.8493 61.4155C41.011 63.2501 43.4656 64.7085 46.1106 65.7298Z"
      fill="#FAFAFA"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.6917 72.4975H66.2281L64.3525 65.7298C66.9975 64.7085 69.4522 63.2501 71.6139 61.4155L74.6917 72.4975Z"
      fill="#FAFAFA"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.0381 52.3652C46.1893 54.701 49.0168 56.3058 52.1251 56.9553C55.2334 57.6048 58.467 57.2664 61.3735 55.9875C64.2799 54.7086 66.714 52.5531 68.335 49.8226C69.956 47.0922 70.683 43.9232 70.4142 40.7592C70.1454 37.5952 68.8943 34.5943 66.8359 32.1764C64.7775 29.7585 62.0147 28.0445 58.9341 27.2743C55.8536 26.504 52.6093 26.7159 49.6551 27.8804C46.7009 29.0449 44.1846 31.1038 42.4582 33.7689C42.4448 33.7836 42.4448 33.7836 42.4448 33.797M32.9707 54.2261L33.2529 53.9439L36.7486 50.4616M36.7486 50.4616C36.7486 46.2044 38.9292 42.5786 40.0195 41.2979C40.3063 40.943 40.6122 40.6041 40.9358 40.2825L43.4125 37.801L45.1035 41.6082C45.0802 41.7524 45.0708 41.8984 45.0754 42.0444V42.158L45.2587 41.9748L49.4606 43.7232L46.9558 46.1901C46.7444 46.4015 46.5184 46.6128 46.2789 46.8096C44.9929 47.9301 43.518 48.8134 41.9231 49.4182C41.114 49.766 38.9464 50.4616 36.7486 50.4616ZM41.8094 57.2709C40.6329 56.2375 39.5825 55.0686 38.6803 53.7887L41.8094 57.2709ZM38.8489 61.4154C37.3866 60.1858 36.0673 58.7956 34.9159 57.2709L38.8489 61.4154Z"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.4777 60.8094C51.5024 62.4731 55.9555 62.7986 60.1794 61.7378C64.4032 60.677 68.1741 58.2861 70.9352 54.9182C73.6962 51.5502 75.3012 47.3837 75.5131 43.0338C75.7249 38.6839 74.5325 34.3812 72.1118 30.7608C69.6911 27.1405 66.1704 24.3945 62.0696 22.9282C57.9688 21.462 53.5052 21.3531 49.3378 22.6178C45.1704 23.8826 41.5202 26.4538 38.9259 29.9518C36.3317 33.4499 34.931 37.6894 34.9307 42.0445C34.9307 42.2986 34.9307 42.5528 34.9441 42.8069V42.8204"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.4207 50.8002C30.3788 47.9987 29.8471 45.0334 29.8506 42.0445C29.8536 36.6306 31.5888 31.3597 34.8023 27.0027C38.0158 22.6457 42.5391 19.4312 47.7106 17.8293C52.882 16.2274 58.4304 16.3221 63.5441 18.0997C68.6579 19.8772 73.0687 23.2443 76.1316 27.7085C79.1945 32.1727 80.7486 37.4998 80.5668 42.9106C80.385 48.3214 78.4767 53.5321 75.1211 57.7807C71.7655 62.0292 67.1385 65.0926 61.917 66.5228C56.6954 67.9531 51.1533 67.6752 46.101 65.7297"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.0386 52.3652C46.1898 54.701 49.0173 56.3058 52.1256 56.9553C55.2339 57.6048 58.4675 57.2664 61.374 55.9875C64.2805 54.7086 66.7145 52.5531 68.3355 49.8226C69.9566 47.0922 70.6835 43.9232 70.4147 40.7592C70.1459 37.5952 68.8948 34.5943 66.8364 32.1764C64.778 29.7585 62.0152 28.0445 58.9347 27.2743C55.8541 26.504 52.6098 26.7159 49.6556 27.8804C46.7014 29.0449 44.1851 31.1038 42.4587 33.7689C42.4453 33.7836 42.4453 33.7836 42.4453 33.797"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.7119 36.5328C47.8392 34.7886 49.4743 33.432 51.3966 32.646C53.319 31.8601 55.4361 31.6827 57.4625 32.1376C59.4889 32.5926 61.327 33.6581 62.7288 35.1903C64.1307 36.7226 65.029 38.648 65.3024 40.7067C65.5758 42.7655 65.2112 44.8585 64.2578 46.7036C63.3045 48.5487 61.8082 50.057 59.9708 51.025C58.1334 51.9931 56.0433 52.3744 53.9825 52.1175C51.9216 51.8605 49.9891 50.9777 48.4457 49.5881"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.116 46.0483C53.0045 46.7458 54.1022 47.1233 55.2317 47.1199C56.1609 47.1193 57.072 46.8637 57.8659 46.3809C58.6597 45.8981 59.3058 45.2067 59.7338 44.3819C60.1617 43.5572 60.355 42.6308 60.2927 41.7038C60.2303 40.7767 59.9147 39.8846 59.3802 39.1246C58.8457 38.3646 58.1128 37.7659 57.2615 37.3938C56.4101 37.0216 55.4729 36.8903 54.5521 37.0142C53.6312 37.138 52.762 37.5123 52.0393 38.0961C51.3165 38.68 50.7678 39.451 50.4531 40.3253"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.1088 41.6083C45.0855 41.7525 45.0761 41.8985 45.0807 42.0445V42.1581L40.6821 46.5421L36.815 50.3908H36.8004C36.7707 47.0764 37.9088 43.8573 40.015 41.2979C40.3018 40.9431 40.6077 40.6042 40.9314 40.2826L43.4129 37.8011L45.1088 41.6083Z"
      fill="white"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.4653 43.7232L46.9557 46.1901C46.7443 46.4015 46.5183 46.6129 46.2788 46.8096C44.9927 47.9302 43.5179 48.8134 41.9229 49.4182C40.2963 50.0549 38.5662 50.3863 36.8193 50.3957L40.6816 46.5469L45.0802 42.1629L45.2634 41.9797L49.4653 43.7232Z"
      fill="white"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2635 41.9748L45.0803 42.158V42.0444C45.0756 41.8984 45.085 41.7524 45.1084 41.6082L45.2635 41.9748Z"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.8199 50.3908L36.749 50.4616"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9711 54.2261L14.6436 72.4974"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.2955 31.3718C83.9653 33.2172 84.0066 35.1099 84.417 36.9392C84.8274 38.7684 85.5986 40.4974 86.6854 42.0249C89.7813 39.8228 91.9035 36.5068 92.6064 32.7732L93.2564 29.3179L88.8053 30.2831L84.915 27.9128L84.2955 31.3718Z"
      fill="white"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.7987 30.2868L86.6837 42.0311L82.7652 63.7418L81.7071 69.6213L81.5801 70.3263"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.5044 59.4654L86.7618 63.4975L82.7432 66.3162C82.9005 65.3517 83.1606 64.4067 83.519 63.4975C83.9797 62.3209 84.5878 61.2075 85.3286 60.1838L85.3432 60.1692C86.2399 58.9734 87.3199 57.9268 88.5432 57.0682L91.4047 55.0375L91.588 55.7999L92.5044 59.4654Z"
      fill="white"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.3532 61.9041L94.0549 63.4925L93.4635 63.9006C90.3355 66.0543 86.497 66.9179 82.748 66.3113L86.7667 63.4925L92.5093 59.4604L96.3532 61.9041Z"
      fill="white"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.3994 84.1085L78.6178 69.2205L78.7302 69.1362L82.7476 66.3162"
      stroke="#622C6A"
      strokeWidth="1.22183"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
